import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import HomePage from '@/views/HomePage.vue'
import CareersPage from '@/views/CareersPage.vue'
import ProjectsPage from '@/views/ProjectPage.vue'
import DIV26 from '@/views/divisions/26.vue'
import DIV27 from '@/views/divisions/27.vue'
import DIV28 from '@/views/divisions/28.vue'
import Quote from '@/components/Quote.vue'
import ContactPage from '@/views/ContactPage.vue';
import PolicyPage from '@/views/legal/PolicyPage.vue';
import TermsPage from '@/views/legal/TermsPage.vue';
import CookiePage from '@/views/legal/CookiePage.vue';
import Career from '@/components/Career.vue';
import NotFound from '@/views/errors/404.vue';
import ProjectCollage from '@/components/objects/Project.vue'
const routes: Array<RouteRecordRaw> = [

  // Home page
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: HomePage
  },

  // Privacy Policy
  {
    path: '/privacy',
    name: 'Privacy Policy',
    component: PolicyPage
  },
  {
    path: '/policy',
    redirect: '/privacy'
  },


  // Terms of Service

  {
    path: '/terms',
    name: 'Terms of Service',
    component: TermsPage
  },
  {
    path: '/tos',
    redirect: '/terms'
  },

  // Cookie Policy

  {
    path: '/cookies',
    name: 'Cookies Policy',
    component: CookiePage
  },




  // general Pages

  {
    path: '/careers',
    name: 'Careers',
    component: CareersPage
  }, {
    path: '/contact',
    name: 'Contact',
    component: ContactPage
  },{
    path: '/div26',
    name: 'Electrical Systems',
    component: DIV26
  }, {
    path: '/div27',
    name: 'Communications Systems',
    component: DIV27
  }, {
    path: '/div28',
    name: 'Security Systems',
    component: DIV28
  },
  //project pages



  {
    path: '/projects',
    name: 'Projects',
    component: ProjectsPage
  }, 
  
  {
    path: '/project',
    name: 'Project Collage',
    component: ProjectCollage
  }, 
  /// modals


  // quote pages

  {
    path: '/requestquote/:division',
    name: 'Request Quote With Division',
    component: Quote,

  }

  , {
    path: '/requestquote/:catchAll(.*)*',
    redirect: '/requestquote/request'
  },
  //career
  {
    path: '/career',
    name: 'Request Quote',
    component: Career
  },
        { path: '/:pathMatch(.*)*', name:"404 | Not Found", component: NotFound }


]
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})
console.log(router.getRoutes())
export default router
